export const logos = {
  bx5l8fbn: 'catch22',
  t9xudjjw: 'catch22',
  '7f9fos2w': 'catch22',
  iruxc7hd: 'catch22',
  xemuihdi: 'eatopi',
  or7omv7e: 'eatopi',
  '7fh2s40v': 'circle-cafe',
  '7wyjudqe': 'circle-cafe',
  '18jfq4de': 'circle-cafe',
  ro1pngrh: 'circle-cafe',
  lravwgth: 'circle-cafe',
  '8vkzaf2t': 'circle-cafe',
  aq0p9eve: 'circle-cafe',
  '53yjhsfd': 'circle-cafe',
  '9amiu8vj': 'circle-cafe',
  wzhqa35n: 'circle-cafe',
  '1u3f0opa': 'zaroob',
  c9jkuypi: 'zaroob',
  rjk3737q: 'zaroob',
  tt3s02p1: 'zaroob',
  '8cepoov1': 'kitopi',
  npiosai2: 'taqado',
  jaf3chk8: 'taqado',
  g7cc2hqp: 'taqado',
  kl3y9ooy: 'taqado',
  '3bmk3j15': 'taqado',
  hxepc36u: 'taqado',
  ds0h3xhu: 'taqado',
  syz25k85: 'taqado',
  '2rdbsusw': 'taqado',
  ao6xp9f2: 'taqado',
  pgi6mvm3: 'taqado',
  zotqpl9i: 'taqado',
  '7z52amdf': 'taqado',
  '0cxzylr0': 'circle-cafe',
  kngawbka: 'taqado',
  fefig41t: 'taqado',
  yl5ku46f: 'cali-poke',
  tvd05d0u: '800-pizza',
  ujix9jr8: 'circle-cafe',
  mb256na6: 'circle-cafe',
  tt7d4wdv: '800-pizza',
  rfulczib: '800-pizza',
  tzo0qjrt: 'cali-poke',
  tcn4t63u: 'cali-poke',
  yn9rg9i6: 'cali-poke',
  nyrmrvtq: 'chinchin',
  rxv2wln9: 'chinchin',
  xnc5p0dz: 'chinchin',
  fugvn93o: 'chinchin',
  xe75o99d: 'chinchin',
  '1wbf3xwo': 'chinchin',
  t8ykoz8z: 'chinchin',
  d0ahfwj4: 'chinchin',
  wi087k59: 'chinchin',
  lwi8lh7f: 'chinchin',
  fuhchxpj: 'chinchin',
  e0slurat: 'chinchin',
  wcn0qrs7: 'chinchin',
  oofyafgo: 'chinchin',
  fqw5551j: 'chinchin',
  d6pnhl7w: 'chinchin',
  '3h9f2oh4': 'chinchin',
  ihqx4ijs: 'operation-falafel',
  sxk720we: 'operation-falafel',
  '3p00onh1': 'operation-falafel',
  ho39a90s: 'operation-falafel',
  cfwbne3u: 'operation-falafel',
  x3cyw7rd: 'operation-falafel',
  '5sjv61q3': 'highjoint',
  tgea7yt0: 'highjoint',
  fz72vpkg: 'highjoint',
  '3p2i8qhk': 'highjoint',
  '404m19gd': 'highjoint',
  w11z7upe: 'go-greek',
  uwl4pbny: 'go-greek',
  jugzpbj0: 'awani',
  ks26ea66: 'awani',
  '4tt2oa5i': 'awani',
  ouisoq9a: 'awani',
  m9roze1f: 'awani',
  nwrtgif4: 'awani',
  f6v7bffg: 'awani',
  vb8jl2hz: 'awani',
  // New brand logos
  hlgc0kjy: 'katsu&co',
  ts70kmo9: 'pizzaro',
  kinqq6qr: 'pizzaro',
  lh73sxm5: 'pizzaro',
  kufd6olo: 'pizzaro',
  '1fbgekbl': 'biryani-pot',
  mmzqts34: 'biryani-pot',
  rr83ahii: 'poke-poke',
  unmpu2xw: 'johnny-rocket',
  hhz1wm7f: 'kava-and-chai',
  zdn2dkgn: 'kava-and-chai',
  kdkbnej5: 'hotbun',
  '07h00k83': 'flavour-fields',
  v84r2msq: 'highjoint',
};
